import { render } from "./capitalFlow.vue?vue&type=template&id=52f2c2d8&scoped=true"
import script from "./capitalFlow.vue?vue&type=script&lang=js"
export * from "./capitalFlow.vue?vue&type=script&lang=js"

import "./capitalFlow.vue?vue&type=style&index=0&id=52f2c2d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f2c2d8"]])

export default __exports__